import * as React from "react";
import { SVGProps } from "react";

const BitforexToken = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path fill="#265fac" d="M0 0h512v512H0z" />
    <path
      fill="#fff"
      d="M423.47 170.08c-4.92 53.68-58.11 46.94-58.11 46.94v-46.94h-53.33v46.94H196.91v-46.94h-52.22v46.8c-52.45 3.2-55.91-45.8-55.91-45.8H36.34v2.16a95.35 95.35 0 0 0 92.73 95.32l15.13.41v66.86a102.31 102.31 0 0 0 102.3 102.31h16.65a102.63 102.63 0 0 0 102.32-102.32v-67.23h15.77a94.43 94.43 0 0 0 94.43-94.43v-4.08h-52.2Zm-111.19 160a57.45 57.45 0 1 1-114.88 1.84v-64.44h114.88v62.6Z"
    />
  </svg>
);

export default BitforexToken;
